import { PROFILE_STATUS, useVerifyProfile } from '@/providers/VerifyProfileProvider';
import { ProfileCongrats } from './ProfileCongrats';
import { ProfileEmailContent } from './ProfileEmailContent';
import { ProfileEmailContentSuccess } from './ProfileEmailContentSuccess';
import { ProfileIntro } from './ProfileIntro';
import { ProfileWelcome } from './ProfileWelcome';
export const ProfileLeftSection: React.FC = () => {
  const {
    status,
    successes
  } = useVerifyProfile();
  return <>
      {status === PROFILE_STATUS.REGISTRATION ? <ProfileIntro /> : status === PROFILE_STATUS.VERIFY && !successes.has(PROFILE_STATUS.VERIFY) ? <ProfileEmailContent /> : status === PROFILE_STATUS.VERIFY && successes.has(PROFILE_STATUS.VERIFY) ? <ProfileEmailContentSuccess /> : status === PROFILE_STATUS.COMPLETE && !successes.has(PROFILE_STATUS.COMPLETE) ? <ProfileWelcome /> : status === PROFILE_STATUS.VERIFICATION && !successes.has(PROFILE_STATUS.VERIFICATION) ? <ProfileWelcome /> : status === PROFILE_STATUS.VERIFICATION && successes.has(PROFILE_STATUS.VERIFICATION) ? <ProfileCongrats /> : null}
    </>;
};